var version = {
    "name":      "dativery",
    "buildDateCode": "20260420-140846",
    "buildDate": "Mon Apr 20 2026 14:08:46 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260420-140846",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;